/**
 * Neobrutalism Motion Config
 *
 * Spring physics matching chamama videogame theme DNA.
 * Plain objects consumed by framer-motion in apps/frontend.
 * No framer-motion dependency here — just variant definitions.
 */

/** Spring presets — matched to chamama (stiffness 350, damping 30) */
export const springs = {
  /** Snappy spring for buttons, small interactions */
  snappy: { type: 'spring' as const, stiffness: 400, damping: 25 },
  /** Default spring for page transitions, cards (chamama DNA) */
  default: { type: 'spring' as const, stiffness: 350, damping: 30 },
  /** Gentle spring for large containers, modals */
  gentle: { type: 'spring' as const, stiffness: 200, damping: 25 },
} as const;

/** Neo animation variants — chamama videogame theme DNA */
export const subtleNeo = {
  /** Page-level container that staggers its children */
  pageContainer: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.06,
        delayChildren: 0.05,
      },
    },
  },

  /** Individual stagger item (child of pageContainer) */
  staggerItem: {
    hidden: { opacity: 0, scale: 0.95, y: 20 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: springs.default,
    },
  },

  /** Modal / overlay content entrance */
  modalContent: {
    hidden: { opacity: 0, scale: 0.95, y: 8 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: springs.gentle,
    },
    exit: {
      opacity: 0,
      scale: 0.97,
      y: 4,
      transition: { duration: 0.15 },
    },
  },

  /** Fade in (simple, for detail/form pages) */
  fadeIn: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.25 },
    },
  },

  /** Slide up fade (for cards, sections) */
  slideUp: {
    hidden: { opacity: 0, y: 16 },
    visible: {
      opacity: 1,
      y: 0,
      transition: springs.default,
    },
  },

  /** Tap feedback for interactive cards */
  tap: { scale: 0.98 },
} as const;
